import { Injectable, Signal, inject } from '@angular/core';

import { makeItemId } from '../functions/dashboard-chart.functions';
import type { TableBuilderConfig } from '../types/table-builder.type';
import { UserPreferencesService } from './user-preferences.service';

@Injectable({ providedIn: 'root' })
export class TableBuilderConfigsService {
  private readonly prefs = inject(UserPreferencesService);

  readonly configs: Signal<ReadonlyArray<TableBuilderConfig>> =
    this.prefs.select('tableBuilderConfigs');

  save(entry: Omit<TableBuilderConfig, 'id'>): string {
    const id = makeItemId();
    const config: TableBuilderConfig = { id, ...entry };
    this.prefs.set('tableBuilderConfigs', [...this.prefs.get('tableBuilderConfigs'), config]);
    return id;
  }

  update(id: string, entry: Omit<TableBuilderConfig, 'id'>): void {
    this.prefs.set(
      'tableBuilderConfigs',
      this.prefs.get('tableBuilderConfigs').map((c) => (c.id === id ? { id, ...entry } : c)),
    );
  }

  delete(id: string): void {
    this.prefs.set(
      'tableBuilderConfigs',
      this.prefs.get('tableBuilderConfigs').filter((c) => c.id !== id),
    );
  }
}
